/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type JoinGiveawayErrorResponse = {
    success: boolean;
    /**
     * Specific error code
     */
    error: JoinGiveawayErrorResponse.error;
};
export namespace JoinGiveawayErrorResponse {
    /**
     * Specific error code
     */
    export enum error {
        INSUFFICIENT_STEAM_LEVEL = 'INSUFFICIENT_STEAM_LEVEL',
        INSUFFICIENT_LEVEL = 'INSUFFICIENT_LEVEL',
        INSUFFICIENT_DEPOSIT = 'INSUFFICIENT_DEPOSIT',
        EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
        ALREADY_JOINED = 'ALREADY_JOINED',
        ROUND_NOT_ACCEPTING = 'ROUND_NOT_ACCEPTING',
        ROUND_NOT_FOUND = 'ROUND_NOT_FOUND',
    }
}

